import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { StorePrivacySetting } from './privacy.actions';

export type PrivacySettingKey =
  | 'cmpOption'
  | 'didomiApiKey'
  | 'didomiNoticeId'
  | 'termsOfServiceUrl'
  | 'privacyPolicyUrl';

export interface PrivacySettings {
  cmpOption: boolean;
  didomiApiKey: string;
  didomiNoticeId: string;
  termsOfServiceUrl: string;
  privacyPolicyUrl: string;
}

export interface PrivacyStateModel {
  storedPrivacySettings: PrivacySettings;
}

@State<PrivacyStateModel>({
  name: 'privacy',
  defaults: {
    // settings stored waiting to be sent to the server
    storedPrivacySettings: null,
  },
})
@Injectable()
export class PrivacyState {
  @Selector()
  static storedPrivacySettings(state: PrivacyStateModel): PrivacySettings {
    return state.storedPrivacySettings;
  }

  @Action(StorePrivacySetting)
  storePrivacySetting(
    ctx: StateContext<PrivacyStateModel>,
    { key, value }: StorePrivacySetting,
  ) {
    const state = ctx.getState();
    const updatedSettings = { ...state.storedPrivacySettings, [key]: value };
    ctx.patchState({
      storedPrivacySettings: updatedSettings,
    });
  }
}
